import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./header.css";
import LOGO_URL from "../../assets/icons/logonod.png";
import { ChevronDown } from "lucide-react";

const Header: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const headerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const onScroll = () => {
      if (!headerRef.current) return;
      if (window.scrollY > 8) headerRef.current.classList.add("scrolled");
      else headerRef.current.classList.remove("scrolled");
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 992) setMobileOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  function toggleDropdown(id: string) {
    setOpenDropdown(openDropdown === id ? null : id);
  }

  function closeAll() {
    setMobileOpen(false);
    setOpenDropdown(null);
  }

  return (
    <header className="niw-header" ref={headerRef}>
      <div className="brand">
        {/* ✅ LOGO */}
        <Link className="logo" to="/" onClick={closeAll}>
          <span className="logo-tile">
            <img src={LOGO_URL} alt="Nordic Integration Works" />
          </span>
          <div className="logo-text">
            <strong>
              Nordic <span style={{ color: "#54B1D8" }}>Integration</span> Works
            </strong>
          </div>
        </Link>

        {/* HAMBURGER */}
        <button
          className={`hamburger ${mobileOpen ? "open" : ""}`}
          onClick={() => setMobileOpen((s) => !s)}
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <nav className={`nav ${mobileOpen ? "open" : ""}`} aria-label="Main navigation">
        {/* HOME */}
        <Link to="/" className="nav-link" onClick={closeAll}>
          Home
        </Link>

        {/* SERVICES */}
        <div className={`dropdown-wrapper ${openDropdown === "services" ? "open" : ""}`}>
          <button
            className="nav-link drop-btn"
            onClick={() => toggleDropdown("services")}
          >
            <span>Services</span>
            <ChevronDown
              className={`chev ${openDropdown === "services" ? "rotated" : ""}`}
              size={16}
            />
          </button>

          <div className="dropdown" role="menu">
            <Link to="/services/consulting-service" onClick={closeAll}>
              Consulting Services
            </Link>
            <Link to="/services/staffing-service" onClick={closeAll}>
              Staffing Services
            </Link>
            <Link to="/services/software-service" onClick={closeAll}>
              Software Services
            </Link>
            <Link to="/services/project-service" onClick={closeAll}>
              Project Outsourcing
            </Link>
          </div>
        </div>

        {/* ABOUT */}
        <Link to="/about-us" className="nav-link" onClick={closeAll}>
          About Us
        </Link>

        {/* CAREERS */}
        <Link to="/careers" className="nav-link" onClick={closeAll}>
          Career
        </Link>

        {/* CONTACT */}
        <Link to="/contact-us" className="nav-link" onClick={closeAll}>
          Contact Us
        </Link>
      </nav>
    </header>
  );
};

export default Header;
